module.exports = __webpack_public_path__ + "static/media/menu.4d59b2ba.svg";